module.exports = __webpack_public_path__ + "static/img/design03.5668421.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/design/design03.png
// module id = 6vU7
// module chunks = 1